import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import axios from 'axios';
import StartAdButton from './StartAdButton';

const AdDetails = () => {
    const { id } = useParams();
    const [ad, setAd] = useState(null);

    useEffect(() => {
        const fetchAdDetails = async () => {
            try {
                const response = await axios.get(`https://api.typecopy.co.za/api/Ads/${id}`);
                setAd(response.data);
            } catch (error) {
                console.error('Error fetching ad details:', error);
            }
        };

        fetchAdDetails();
    }, [id]);

    if (!ad) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                {ad.title}
            </Typography>
            <Typography variant="body1" gutterBottom>
                <strong>Niche:</strong> {ad.niche}
            </Typography>
            <Typography variant="body1" gutterBottom>
                <strong>Type:</strong> {ad.type}
            </Typography>
            <Typography variant="body1" gutterBottom>
                <strong>Publisher:</strong> {ad.publisher}
            </Typography>
            <Typography variant="body1" gutterBottom>
                <strong>Publication Date:</strong> {new Date(ad.publicationDate).toLocaleDateString()}
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ whiteSpace: 'pre-wrap' }}>
                <strong>Ad Copy:</strong> {ad.adCopy}
            </Typography>
            <Typography variant="body1" gutterBottom>
                <strong>Copy Count:</strong> {ad.copyCount}
            </Typography>
            <Typography variant="body1" gutterBottom>
                <strong>User Rating:</strong> {ad.userRating}
            </Typography>
            <Typography variant="body1" gutterBottom>
                <strong>Educational Content:</strong> {ad.educationalContent}
            </Typography>
            {ad.imageUrl && (
                <Box my={2}>
                    <img src={ad.imageUrl} alt={ad.title} style={{ maxWidth: '100%' }} />
                </Box>
            )}
            <Box mt={4}>
                <StartAdButton adId={ad.id} />
            </Box>
        </Container>
    );
};

export default AdDetails;